import React, { useRef } from 'react';
import { useParticleField } from '../hooks/useParticleField';

export default function ParticleField() {
  const canvasRef = useRef(null);
  useParticleField(canvasRef);
  return <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" aria-hidden="true" />;
}
